import { CartStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { ProductDetailStore } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { XHR } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

export const getNumericPrice = price => {
  if (typeof price === 'object') {
    return price.numeric;
  }
  return +price;
};

export const productMap = (product, variantId = null) => {
  const { name, currency } = product;
  let { sku } = product;
  let price = product.sale_price || product.price;

  // Grab SKU and price from variant (if applicable)
  if (variantId && product && product.variants.length) {
    const variant = product.variants.find(v => v.id === variantId);
    sku = (variant && variant.sku) || sku;
    price = (variant && (variant.sale_price || variant.price)) || price;
  }

  const numericPrice = getNumericPrice(price);

  const reportingObj = {
    content_ids: [sku],
    content_name: name,
    content_type: 'product',
    value: numericPrice,
    currency: (price && price.currency) || currency
  };

  return reportingObj;
};

class PixelTracker {
  constructor(enabled = false) {
    this.lastEventLogged = 0;
    this.enabled = enabled;
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  logAddToCart(variantId) {
    const { product } = ProductDetailStore.getState();
    this.logEvent('AddToCart', productMap(product, variantId));
  }

  logViewContent() {
    const { product } = ProductDetailStore.getState();
    this.logEvent('ViewContent', productMap(product));
  }

  logInitiateCheckout() {
    const { cart } = CartStore.getState();
    const { currency, total } = cart;
    const lineItems = (cart && cart.line_items) || [];
    if (!lineItems) return;

    const data = {
      content_ids: lineItems.map(li => li.sku),
      num_items: lineItems.map(li => li.quantity).reduce((a, b) => a + b),
      value: getNumericPrice(total),
      currency
    };

    this.logEvent('InitiateCheckout', data);
  }

  logEvent(eventName, data = {}) {
    if (!this.enabled) return null;

    const currentTimestamp = +new Date();
    if (currentTimestamp - this.lastEventLogged < 500) return;
    this.lastEventLogged = currentTimestamp;

    const eventId = `${eventName}_${currentTimestamp}`;

    if (window.fbq) {
      window.fbq('track', eventName, data, { eventID: eventId });
    }

    if (OlsConfigStore.getState().tracks_fbe_pixel) {
      const baseUrl = OlsConfigStore.getApiBaseUrl();
      data.eventId = eventId;

      XHR.postRequest(`${baseUrl}/api/v1/facebook/events`, {
        event: eventName,
        data,
        source_url: window.location.href
      });
    }
  }
}

export default new PixelTracker();
